<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-num"><a id="page_10"></a>Materials &amp; tools</h2>
<p class="h1">Yarn</p>
<p class="fnoindent">I used 20g or 25g balls of DK (8-ply/light worsted) cotton yarn for the projects in this book. These are the perfect size for small amigurumi projects. Other DK yarns can be used, though the projects may differ slightly in size due to the varying thickness or elasticity of different types of yarn. For smaller or larger results, substitute the yarn with one of another weight, for example, 4-ply (fingering) or aran (10-ply/worsted) yarn, remembering to adjust your hook size to suit. A small amount of gold and silver DK lamé yarn was used when making the Angel and Polar Bear.</p>
<p class="h1">Crochet hooks</p>
<p class="fnoindent">A 3.5mm (UK 9/10, US 4) hook was used throughout, but if your tension (gauge) is a little looser and the stuffing starts to show through the stitches, then switch to a smaller hook. Hooks are made in a variety of materials, so choose a hook of your own preference that has a comfortable grip.</p>
<p class="h1">Other materials and tools</p>
<p class="fnoindent">Toy safety eyes in sizes 6mm, 9mm and 10mm were used to bring the projects to life. The eyes and washers, once pressed together, are sturdy and child safe. However, if you are giving a project to a child under 3 years old, always embroider the eyes on instead.</p>
<p class="findent">The projects were stuffed with polyester toy stuffing, which is soft, clean and washable. Use a recycled polyester toy filling or, if you prefer, a natural wool filling, which is hypoallergenic and biodegradable.</p>
<p class="findent">For the embroidered features, I used six-strand cotton embroidery thread in black and red. The strands were split into half and three strands used to embroider mouths, eyelashes and eyebrows, with a sewing needle.</p>
<p class="findent">The Elves’ hats were finished off with 10mm (⅜in) metal bells in gold and red, and red bells were used for the Robin’s feet.</p>
<p class="findent">A 35mm (1⅜in) pompom maker was used for the Snowman’s bobble hat.</p>
<p class="findent">A tapestry needle was used for sewing the projects together and a pair of sharp scissors are essential for snipping yarn.</p>
<p class="findent">Stitch markers come in handy when working in continuous rounds to the mark the end or beginning of a round.</p>
<div class="box_p">
<p class="boxc">UK/US equivalent crochet terms</p>
<p class="boxi">The patterns in this book are written using UK crochet terms. Some US terms for crochet stitches differ from the UK system, as shown below.</p>
<table>
<tbody><tr>
<td><p class="fnoindent"><span class="bold">UK</span></p></td>
<td><p class="fnoindent"><span class="bold">US</span></p></td>
</tr>
<tr>
<td><p class="fnoindent">back post double crochet <span class="bold">bpdc</span></p></td>
<td><p class="fnoindent">back post single crochet <span class="bold">bpsc</span></p></td>
</tr>
<tr>
<td><p class="fnoindent">double crochet <span class="bold">dc</span></p></td>
<td><p class="fnoindent">single crochet <span class="bold">sc</span></p></td>
</tr>
<tr>
<td><p class="fnoindent">double treble crochet <span class="bold">dtr</span></p></td>
<td><p class="fnoindent">treble crochet <span class="bold">tr</span></p></td>
</tr>
<tr>
<td><p class="fnoindent">front post double crochet <span class="bold">fpdc</span></p></td>
<td><p class="fnoindent">front post single crochet <span class="bold">fpsc</span></p></td>
</tr>
<tr>
<td><p class="fnoindent">half treble crochet <span class="bold">htr</span></p></td>
<td><p class="fnoindent">half double crochet <span class="bold">hdc</span></p></td>
</tr>
<tr>
<td><p class="fnoindent">treble crochet <span class="bold">tr</span></p></td>
<td><p class="fnoindent">double crochet <span class="bold">dc</span></p></td>
</tr>
</tbody></table>
</div>
<div class="img_container">
<p class="image"><a id="page_11"></a><img alt="" src="images/6-1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Ch01.vue?d0f4e446